<template>
  <v-text-field
    ref="textField"
    :value="formattedValue"
    :label="label"
    @input="handleInput"
    v-currency="options"
    reverse
    prefix="€"
    :rules="rules"
  />
</template>

<script>
import { setValue, parseCurrency, CurrencyDirective } from "vue-currency-input";

export default {
  directives: {
    currency: CurrencyDirective
  },
  name: "VCurrencyField",
  data() {
    return {
      formattedValue: this.value,
      options: {
        valueAsInteger: false,
        currency: null
        // autoDecimalMode: true
      }
    };
  },
  watch: {
    value(value) {
      setValue(this.$refs.textField.$refs.input, value);
    }
  },
  props: {
    value: { type: Number, default: null },
    label: { type: String, defaul: "" },
    rules: null
  },
  methods: {
    handleInput(value) {
      this.$emit("input", parseCurrency(value, { valueAsInteger: false }));
      this.formattedValue = value;
    }
  }
};
</script>
